<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="franchise" class="flex flex-col">
        <div class="card">
          <card-header :title="'Franquicia #' + franchise.id">
            <template #actions>
              <router-link
                v-if="hasPermission('edit_franchises')"
                :to="{
                  name: 'franchisesEditForm',
                  params: { id: franchise.id },
                }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_franchises')"
                class="delete-icon-button"
                @click.prevent="openDeleteModal()"
              />
            </template>
          </card-header>

          <section-header title="Informacion General" />

          <div class="detail-grid">
            <detail-field label="Nombre" :value="franchise.name" />
            <detail-field label="Franquiciatario" :value="franchise.franchisee_name + ' ' + franchise.franchisee_last_name" />
            <detail-field label="Correo" :value="franchise.franchise_users[0].user.email" />
            <detail-field label="Teléfono" :value="franchise.franchisee_phone" />
            <detail-field label="Fecha de creación" :value="formatDatetime(franchise.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(franchise.updated_at)" />
            <detail-field label="Fondo de Publicidad" :value="integerToCurrency(franchise.advertisement_fund)" />
          </div>

          <section-header title="Usuarios" />

          <table class="table-auto text-sm mt-4 bg-white">
            <thead class="text-left">
              <tr class="bg-primary-100">
                <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
                <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Correo</th>
                <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
                <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Apellido</th>
                <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Rol</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="franchiseUser in franchise.franchise_users"
                :key="franchiseUser.id"
                class="table-row"
              >
                <td class="table-cell">
                  {{ franchiseUser.id }}
                </td>
                <td class="table-cell">
                  {{ franchiseUser.user.email }}
                </td>
                <td class="table-cell">
                  {{ franchiseUser.name }}
                </td>
                <td class="table-cell">
                  {{ franchiseUser.last_name }}
                </td>
                <td class="table-cell">Admin</td>
              </tr>
            </tbody>
          </table>

          <section-header title="Sucursales" />

          <router-link
            v-if="hasPermission('edit_branches')"
            :to="{ name: 'branchesCreateForm' }"
            class="primary-button mx-0 mt-4"
            >Crear Sucursal</router-link
          >

          <table class="table-auto text-sm mt-4 bg-white">
            <thead class="text-left">
              <tr class="bg-primary-100">
                <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
                <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
                <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
                <!-- <th class="p-2">Cantidad</th>
            <th class="p-2">Fecha</th>
            <th class="p-2">Razón</th> -->
                <!-- <th class="p-2">Precio</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="branch in franchise.branches" :key="branch.id" class="table-row">
                <td class="table-cell">
                  {{ branch.id }}
                </td>
                <td class="table-cell">
                  {{ branch.name }}
                </td>

                <td class="table-cell">
                  <div class="flex">
                    <router-link
                      :to="{
                        name: 'branchesDetail',
                        params: { id: branch.id },
                      }"
                      class="secondary-button"
                      >Detalle</router-link
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Franchise Detail",

  data() {
    return {
      franchise: null,
      loading: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.loadFranchise();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadFranchise() {
      this.loading = true;

      try {
        this.franchise = await api.franchises.getById(
          this.$route.params.franchiseId
        );
        this.$store.commit('setBreadcrumbLabel', {
          routeName: 'franchisesDetail',
          label: this.franchise.name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: 'franchisesIndex' });
      }

      this.loading = false;
    },

    getOptions() {
      let options = [];

      if (this.hasPermission("edit_franchises")) {
        options.push({
          action: "edit",
          label: "Editar",
        });
      }

      if (this.hasPermission("delete_franchises")) {
        options.push({
          action: "delete",
          label: "Eliminar",
        });
      }

      return options;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.franchises.delete(this.franchise.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.$router.push({ name: 'franchisesIndex' });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>